export function MarqueeBand({ items }: { items: string[] }) {
  const track = [...items, ...items];

  return (
    <div className="group overflow-hidden bg-accent-lime py-3">
      <div className="animate-marquee flex w-max items-center gap-8">
        {track.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-8">
            <span className="font-mono text-sm font-semibold uppercase tracking-[0.08em] text-ink-black">
              {item}
            </span>
            <span aria-hidden className="text-ink-black/40">
              +
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
